import React from "react";
import AnimatedSection from "../Shared/AnimatedSection";

const CyberAdmissionRequ = () => {
    return (
        <AnimatedSection title="ADMISSION REQUIREMENTS">
            <p className="text-base md:text-lg lg:text-xl text-black leading-loose tracking-wide mb-8">
                The applicant should posses at least four (4) passes in non religious
                subjects in the Certificate of Seconadary Education Examination (CSEE)
                OR should posses the National Vocational Award Level III (Trade Test
                Grade I) in a relevant field from a recognized institution.
            </p>
        </AnimatedSection>
    );
};

export default CyberAdmissionRequ;
